<template>
  <require from="framework/html_behaviors/af-plhrable"></require>

  <div class="form-group bs-form-select">
    <select class="form-control ${controlClass}" value.bind="value" matcher.bind="matcher" disabled.bind="disabled" af-plhrable.bind="placeholder ? true : false" focus.bind="hasfocus" blur.trigger="blur()">
      <option model.bind="placeholderValue" if.bind="placeholder">${placeholder}</option>
      <template repeat.for="option of options" replaceable part="option">
        <option model.bind="getValue(option)" class.bind="getClass(option)">${getName(option)}</option>
      </template>
    </select>
    <small class="form-label" repeat.for="label of labels">${label}</small>
  </div>
</template>
